import React from "react";
import { Header } from "../../../components/Header";
import "./styles.less";
import { useTranslation } from "react-i18next";
import { Footer } from "../../../components/FooterV2";
import { SolutionIndustryBanner } from "../../../blocks/solution-industry-banner";
import { SolutionIndustryChallenge } from "../../../blocks/solution-industry-challenge";
import { SolutionIndustryValue } from "../../../blocks/solution-industry-value";
import { SolutionIndustrySupport } from "../../../blocks/solution-industry-support";
import { CommonPageLink } from "../../../blocks/common-page-link";
import { HomeTryOn } from "../../../blocks/home-try-on";
import { useParams } from "react-router";
import { Helmet } from "react-helmet";

export const SolutionIndustryPage = () => {
  const { t } = useTranslation();
  const { type } = useParams();
  const pagesLink = [
    {
      title: t("common.pageLink.comp.title"),
      description: t("common.pageLink.comp.description"),
      imgurl: "/page-link-comp.png",
      jumpLink: "/learn/guard",
      defaultImg: "//files.authing.co/authing-website/page-link-icon-comp.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-comp.svg",
    },
    {
      title: t("common.pageLink.mfa.title"),
      description: t("common.pageLink.mfa.description"),
      imgurl: "/page-link-mfa.png",
      jumpLink: "/mfa",
      defaultImg: "//files.authing.co/authing-website/page-link-icon-mfa.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-mfa.svg",
    },
    {
      title: t("common.pageLink.verify.title"),
      description: t("common.pageLink.verify.description"),
      imgurl: "/page-link-verify.png",
      jumpLink: "/verify",
      defaultImg:
        "//files.authing.co/authing-website/page-link-icon-verify.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-verify.svg",
    },
    {
      title: t("common.pageLink.database.title"),
      description: t("common.pageLink.database.description"),
      imgurl: "/page-link-database-connection.png",
      jumpLink: "/database-connection",
      defaultImg:
        "//files.authing.co/authing-website/page-link-icon-database.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-database.svg",
    },
  ];
  const data = {
    enterprise: {
      "helmet-title":
        "企业服务行业身份认证 IDaaS 解决方案-出版行业可信身份认证-Authing 身份云以开发者为中心",
      title: t("solution.detail.enterprise.title"),
      subtitle: t("solution.detail.enterprise.sub"),
      supportTitle: t("solution.detail.enterprise.support.title"),
      imgUrl:
        "//files.authing.co/authing-website/solution-industry-banner-img-v2.png",
      challenges: [
        {
          icon: "icon authing-icon authing-building-line1 icon-style",
          title: t("solution.detail.enterprise.challenges.item-one.title"),
          content: t("solution.detail.enterprise.challenges.item-one.content"),
        },
        {
          icon: "icon authing-icon authing-user-settings-line icon-style",
          title: t("solution.detail.enterprise.challenges.item-two.title"),
          content: t("solution.detail.enterprise.challenges.item-two.content"),
        },
        {
          icon: "icon authing-icon authing-apps-2-line icon-style",
          title: t("solution.detail.enterprise.challenges.item-three.title"),
          content: t(
            "solution.detail.enterprise.challenges.item-three.content"
          ),
        },
        {
          icon: "icon authing-icon authing-line-chart-line icon-style",
          title: t("solution.detail.enterprise.challenges.item-four.title"),
          content: t("solution.detail.enterprise.challenges.item-four.content"),
        },
      ],
      values: [
        {
          type: "value-menu-item-one",
          title: t("solution.detail.enterprise.values.item-one.title"),
          descript: t("solution.detail.enterprise.values.item-one.content"),
        },
        {
          type: "value-menu-item-two",
          title: t("solution.detail.enterprise.values.item-two.title"),
          descript: t("solution.detail.enterprise.values.item-two.content"),
        },
        {
          type: "value-menu-item-three",
          title: t("solution.detail.enterprise.values.item-three.title"),
          descript: t("solution.detail.enterprise.values.item-three.content"),
        },
        {
          type: "value-menu-item-four",
          title: t("solution.detail.enterprise.values.item-four.title"),
          descript: t("solution.detail.enterprise.values.item-four.content"),
        },
      ],
    },
    medical: {
      "helmet-title":
        "医疗行业身份认证  IDaaS 解决方案-医疗信息化解决方案-Authing 身份云以开发者为中心",
      title: t("solution.detail.medical.title"),
      subtitle: t("solution.detail.medical.sub"),
      supportTitle: t("solution.detail.medical.support.title"),
      imgUrl:
        "//files.authing.co/authing-website/solution-industry-banner-medical-v2.png",
      challenges: [
        {
          title: t("solution.detail.medical.challenges.item-one.title"),
          content: t("solution.detail.medical.challenges.item-one.content"),
          icon: "icon authing-icon authing-database-2-line icon-style",
        },
        {
          title: t("solution.detail.medical.challenges.item-two.title"),
          content: t("solution.detail.medical.challenges.item-two.content"),
          icon: "icon authing-icon authing-stethoscope-line icon-style",
        },
        {
          title: t("solution.detail.medical.challenges.item-three.title"),
          content: t("solution.detail.medical.challenges.item-three.content"),
          icon: "icon authing-icon authing-nurse-line icon-style",
        },
        {
          title: t("solution.detail.medical.challenges.item-four.title"),
          content: t("solution.detail.medical.challenges.item-four.content"),
          icon: "icon authing-icon authing-first-aid-kit-line icon-style",
        },
      ],
      values: [
        {
          type: "value-menu-item-one",
          title: t("solution.detail.medical.values.item-one.title"),
          descript: t("solution.detail.medical.values.item-one.content"),
        },
        {
          type: "value-menu-item-two",
          title: t("solution.detail.medical.values.item-two.title"),
          descript: t("solution.detail.medical.values.item-two.content"),
        },
        {
          type: "value-menu-item-three",
          title: t("solution.detail.medical.values.item-three.title"),
          descript: t("solution.detail.medical.values.item-three.content"),
        },
        {
          type: "value-menu-item-four",
          title: t("solution.detail.medical.values.item-four.title"),
          descript: t("solution.detail.medical.values.item-four.content"),
        },
      ],
    },
    game: {
      "helmet-title":
        "游戏行业身份认证 IDaaS 解决方案-网络游戏身份认证解决方案-Authing 身份云以开发者为中心",
      title: t("solution.detail.game.title"),
      subtitle: t("solution.detail.game.sub"),
      supportTitle: t("solution.detail.game.support.title"),
      imgUrl:
        "//files.authing.co/authing-website/solution-industry-banner-game-v2.png",
      challenges: [
        {
          title: t("solution.detail.game.challenges.item-one.title"),
          content: t("solution.detail.game.challenges.item-one.content"),
          icon: "icon authing-icon authing-shield-flash-line icon-style",
        },
        {
          title: t("solution.detail.game.challenges.item-two.title"),
          content: t("solution.detail.game.challenges.item-two.content"),
          icon: "icon authing-icon authing-equalizer-line1 icon-style",
        },
        {
          title: t("solution.detail.game.challenges.item-three.title"),
          content: t("solution.detail.game.challenges.item-three.content"),
          icon: "icon authing-icon authing-hand-coin-line icon-style",
        },
        {
          title: t("solution.detail.game.challenges.item-four.title"),
          content: t("solution.detail.game.challenges.item-four.content"),
          icon: "icon authing-icon authing-flow-chart icon-style",
        },
      ],
      values: [
        {
          type: "value-menu-item-one",
          title: t("solution.detail.game.values.item-one.title"),
          descript: t("solution.detail.game.values.item-one.content"),
        },
        {
          type: "value-menu-item-two",
          title: t("solution.detail.game.values.item-two.title"),
          descript: t("solution.detail.game.values.item-two.content"),
        },
        {
          type: "value-menu-item-three",
          title: t("solution.detail.game.values.item-three.title"),
          descript: t("solution.detail.game.values.item-three.content"),
        },
        {
          type: "value-menu-item-four",
          title: t("solution.detail.game.values.item-four.title"),
          descript: t("solution.detail.game.values.item-four.content"),
        },
      ],
    },
    software: {
      "helmet-title":
        "科技行业身份认证 IDaaS 解决方案-科技行业可信身份认证-Authing 身份云以开发者为中心",
      title: t("solution.detail.software.title"),
      subtitle: t("solution.detail.software.sub"),
      supportTitle: t("solution.detail.software.support.title"),
      imgUrl:
        "//files.authing.co/authing-website/solution-industry-banner-software-v2.png",
      challenges: [
        {
          title: `${t("solution.detail.software.challenges.item-one.title")}`,
          content: `${t(
            "solution.detail.software.challenges.item-one.content"
          )}`,
          icon: "icon authing-icon authing-code-s-slash-line icon-style",
        },
        {
          title: `${t("solution.detail.software.challenges.item-two.title")}`,
          content: `${t(
            "solution.detail.software.challenges.item-two.content"
          )}`,
          icon: "icon authing-icon authing-shield-flash-line icon-style",
        },
        {
          title: `${t("solution.detail.software.challenges.item-three.title")}`,
          content: `${t(
            "solution.detail.software.challenges.item-three.content"
          )}`,
          icon: "icon authing-icon authing-line-chart-line icon-style",
        },
        {
          title: `${t("solution.detail.software.challenges.item-four.title")}`,
          content: `${t(
            "solution.detail.software.challenges.item-four.content"
          )}`,
          icon: "icon authing-icon authing-money-cny-circle-line1 icon-style",
        },
      ],
      values: [
        {
          type: "value-menu-item-one",
          title: t("solution.detail.software.values.item-one.title"),
          descript: t("solution.detail.software.values.item-one.content"),
        },
        {
          type: "value-menu-item-two",
          title: t("solution.detail.software.values.item-two.title"),
          descript: t("solution.detail.software.values.item-two.content"),
        },
        {
          type: "value-menu-item-three",
          title: t("solution.detail.software.values.item-three.title"),
          descript: t("solution.detail.software.values.item-three.content"),
        },
        {
          type: "value-menu-item-four",
          title: t("solution.detail.software.values.item-four.title"),
          descript: t("solution.detail.software.values.item-four.content"),
        },
      ],
    },
    government: {
      "helmet-title":
        "政府行业身份认证 IDaaS 解决方案-政府网站群解决方案-Authing 身份云以开发者为中心",
      title: `${t("solution.detail.government.title")}`,
      subtitle: `${t("solution.detail.government.sub")}`,
      supportTitle: t("solution.detail.government.support.title"),
      imgUrl:
        "//files.authing.co/authing-website/solution-industry-banner-government-v2.png",
      challenges: [
        {
          title: `${t("solution.detail.government.challenges.item-one.title")}`,
          content: `${t(
            "solution.detail.government.challenges.item-one.content"
          )}`,
          icon: "icon authing-icon authing-database-line icon-style",
        },
        {
          title: `${t("solution.detail.government.challenges.item-two.title")}`,
          content: `${t(
            "solution.detail.government.challenges.item-two.content"
          )}`,
          icon: "icon authing-icon authing-money-cny-circle-line1 icon-style",
        },
        {
          title: `${t(
            "solution.detail.government.challenges.item-three.title"
          )}`,
          content: `${t(
            "solution.detail.government.challenges.item-three.content"
          )}`,
          icon: "icon authing-icon authing-terminal-window-line icon-style",
        },
        {
          title: `${t(
            "solution.detail.government.challenges.item-four.title"
          )}`,
          content: `${t(
            "solution.detail.government.challenges.item-four.content"
          )}`,
          icon: "icon authing-icon authing-service-line icon-style",
        },
      ],
      values: [
        {
          type: "value-menu-item-one",
          title: t("solution.detail.government.values.item-one.title"),
          descript: t("solution.detail.government.values.item-one.content"),
        },
        {
          type: "value-menu-item-two",
          title: t("solution.detail.government.values.item-two.title"),
          descript: t("solution.detail.government.values.item-two.content"),
        },
        {
          type: "value-menu-item-three",
          title: t("solution.detail.government.values.item-three.title"),
          descript: t("solution.detail.government.values.item-three.content"),
        },
        {
          type: "value-menu-item-four",
          title: t("solution.detail.government.values.item-four.title"),
          descript: t("solution.detail.government.values.item-four.content"),
        },
      ],
    },
    finance: {
      "helmet-title":
        "金融行业身份认证 IDaaS 解决方案-金融行业统一身份认证解决-Authing身份云以开发者为中心",
      title: `${t("solution.detail.finance.title")}`,
      subtitle: `${t("solution.detail.finance.sub")}`,
      supportTitle: t("solution.detail.finance.support.title"),
      imgUrl:
        "//files.authing.co/authing-website/solution-industry-banner-finance-v2.png",
      challenges: [
        {
          title: `${t("solution.detail.finance.challenges.item-one.title")}`,
          content: `${t(
            "solution.detail.finance.challenges.item-one.content"
          )}`,
          icon: "icon authing-icon authing-user-smile-line icon-style",
        },
        {
          title: `${t("solution.detail.finance.challenges.item-two.title")}`,
          content: `${t(
            "solution.detail.finance.challenges.item-two.content"
          )}`,
          icon: "icon authing-icon authing-organization-chart1 icon-style",
        },
        {
          title: `${t("solution.detail.finance.challenges.item-three.title")}`,
          content: `${t(
            "solution.detail.finance.challenges.item-three.content"
          )}`,
          icon: "icon authing-icon authing-shield-flash-line icon-style",
        },
        {
          title: `${t("solution.detail.finance.challenges.item-four.title")}`,
          content: `${t(
            "solution.detail.finance.challenges.item-four.content"
          )}`,
          icon: "icon authing-icon authing-device-line icon-style",
        },
      ],
      values: [
        {
          type: "value-menu-item-one",
          title: t("solution.detail.finance.values.item-one.title"),
          descript: t("solution.detail.finance.values.item-one.content"),
        },
        {
          type: "value-menu-item-two",
          title: t("solution.detail.finance.values.item-two.title"),
          descript: t("solution.detail.finance.values.item-two.content"),
        },
        {
          type: "value-menu-item-three",
          title: t("solution.detail.finance.values.item-three.title"),
          descript: t("solution.detail.finance.values.item-three.content"),
        },
        {
          type: "value-menu-item-four",
          title: t("solution.detail.finance.values.item-four.title"),
          descript: t("solution.detail.finance.values.item-four.content"),
        },
      ],
    },
    publisher: {
      "helmet-title":
        "出版行业身份认证 IDaaS 解决方案-出版行业可信身份认证-Authing 身份云以开发者为中心",
      title: `${t("solution.detail.publisher.title")}`,
      subtitle: `${t("solution.detail.publisher.sub")}`,
      supportTitle: t("solution.detail.publisher.support.title"),
      imgUrl:
        "//files.authing.co/authing-website/solution-industry-banner-publisher-v2.png",
      challenges: [
        {
          title: `${t("solution.detail.publisher.challenges.item-one.title")}`,
          content: `${t(
            "solution.detail.publisher.challenges.item-one.content"
          )}`,
          icon: "icon authing-icon authing-line-chart-line icon-style",
        },
        {
          title: `${t("solution.detail.publisher.challenges.item-two.title")}`,
          content: `${t(
            "solution.detail.publisher.challenges.item-two.content"
          )}`,
          icon: "icon authing-icon authing-code-s-slash-line icon-style",
        },
        {
          title: `${t(
            "solution.detail.publisher.challenges.item-three.title"
          )}`,
          content: `${t(
            "solution.detail.publisher.challenges.item-three.content"
          )}`,
          icon: "icon authing-icon authing-rotate-lock-line icon-style",
        },
        {
          title: `${t("solution.detail.publisher.challenges.item-four.title")}`,
          content: `${t(
            "solution.detail.publisher.challenges.item-four.content"
          )}`,
          icon: "icon authing-icon authing-shield-flash-line icon-style",
        },
      ],
      values: [
        {
          type: "value-menu-item-one",
          title: t("solution.detail.publisher.values.item-one.title"),
          descript: t("solution.detail.publisher.values.item-one.content"),
        },
        {
          type: "value-menu-item-two",
          title: t("solution.detail.publisher.values.item-two.title"),
          descript: t("solution.detail.publisher.values.item-two.content"),
        },
        {
          type: "value-menu-item-three",
          title: t("solution.detail.publisher.values.item-three.title"),
          descript: t("solution.detail.publisher.values.item-three.content"),
        },
        {
          type: "value-menu-item-four",
          title: t("solution.detail.publisher.values.item-four.title"),
          descript: t("solution.detail.publisher.values.item-four.content"),
        },
      ],
    },
    education: {
      "helmet-title":
        "教育行业身份认证 IDaaS 解决方案-数字校园统一身份认证-Authing 身份云以开发者为中心",
      title: `${t("solution.detail.education.title")}`,
      subtitle: `${t("solution.detail.education.sub")}`,
      supportTitle: t("solution.detail.education.support.title"),
      imgUrl:
        "//files.authing.co/authing-website/solution-industry-banner-education-v2.png",
      challenges: [
        {
          title: `${t("solution.detail.education.challenges.item-one.title")}`,
          content: `${t(
            "solution.detail.education.challenges.item-one.content"
          )}`,
          icon: "icon authing-icon authing-shield-user-line icon-style",
        },
        {
          title: `${t("solution.detail.education.challenges.item-two.title")}`,
          content: `${t(
            "solution.detail.education.challenges.item-two.content"
          )}`,
          icon: "icon authing-icon authing-tv-2-line icon-style",
        },
        {
          title: `${t(
            "solution.detail.education.challenges.item-three.title"
          )}`,
          content: `${t(
            "solution.detail.education.challenges.item-three.content"
          )}`,
          icon: "icon authing-icon authing-rotate-lock-line icon-style",
        },
        {
          title: `${t("solution.detail.education.challenges.item-four.title")}`,
          content: `${t(
            "solution.detail.education.challenges.item-four.content"
          )}`,
          icon: "icon authing-icon authing-exchange-line2 icon-style",
        },
      ],
      values: [
        {
          type: "value-menu-item-one",
          title: t("solution.detail.education.values.item-one.title"),
          descript: t("solution.detail.education.values.item-one.content"),
        },
        {
          type: "value-menu-item-two",
          title: t("solution.detail.education.values.item-two.title"),
          descript: t("solution.detail.education.values.item-two.content"),
        },
        {
          type: "value-menu-item-three",
          title: t("solution.detail.education.values.item-three.title"),
          descript: t("solution.detail.education.values.item-three.content"),
        },
        {
          type: "value-menu-item-four",
          title: t("solution.detail.education.values.item-four.title"),
          descript: t("solution.detail.education.values.item-four.content"),
        },
      ],
    },
    consume: {
      "helmet-title":
        "新消费行业身份认证 IDaaS 解决方案-网络游戏身份认证解决方案-Authing 身份云以开发者为中心",
      title: t("solution.detail.consume.title"),
      subtitle: t("solution.detail.consume.sub"),
      supportTitle: t("solution.detail.consume.support.title"),
      isSSO: true,
      imgUrl:
        "//files.authing.co/authing-website/solution-industry-banner-retail-v2.png",
      challenges: [
        {
          title: t("solution.detail.consume.challenges.item-one.title"),
          content: t("solution.detail.consume.challenges.item-one.content"),
          icon: "icon authing-icon authing-apps-2-line icon-style",
        },
        {
          title: t("solution.detail.consume.challenges.item-two.title"),
          content: t("solution.detail.consume.challenges.item-two.content"),
          icon: "icon authing-icon authing-team-line1 icon-style",
        },
        {
          title: t("solution.detail.consume.challenges.item-three.title"),
          content: t("solution.detail.consume.challenges.item-three.content"),
          icon: "icon authing-icon authing-rotate-lock-line icon-style",
        },
        {
          title: t("solution.detail.consume.challenges.item-four.title"),
          content: t("solution.detail.consume.challenges.item-four.content"),
          icon: "icon authing-icon authing-database-line icon-style",
        },
      ],
      values: [
        {
          type: "value-menu-item-one",
          title: t("solution.detail.consume.values.item-one.title"),
          descript: t("solution.detail.consume.values.item-one.content"),
        },
        {
          type: "value-menu-item-two",
          title: t("solution.detail.consume.values.item-two.title"),
          descript: t("solution.detail.consume.values.item-two.content"),
        },
        {
          type: "value-menu-item-three",
          title: t("solution.detail.consume.values.item-three.title"),
          descript: t("solution.detail.consume.values.item-three.content"),
        },
        {
          type: "value-menu-item-four",
          title: t("solution.detail.consume.values.item-four.title"),
          descript: t("solution.detail.consume.values.item-four.content"),
        },
      ],
    },
  };
  return (
    <div className="solution-industry-page">
      <Helmet>
        <title>{data[type]["helmet-title"]}</title>
      </Helmet>
      <Header key={type} mode={"light"} />
      <SolutionIndustryBanner
        title={data[type].title}
        subtitle={data[type].subtitle}
        imgUrl={data[type].imgUrl}
      />
      {/* <SolutionIndustryCustomer /> */}
      <SolutionIndustryChallenge challenges={data[type].challenges} />
      <SolutionIndustryValue values={data[type].values} />
      <SolutionIndustrySupport
        isSSO={data[type].isSSO}
        supportTitle={data[type].supportTitle}
      />
      <CommonPageLink pagesLink={pagesLink} />
      <div className="solution-industry-homeTryOn-bg">
        <HomeTryOn />
      </div>
      <Footer />
    </div>
  );
};
